import { ref } from 'vue'

// This state is shared across all components that use this composable
const toast = ref({
  show: false,
  message: '',
  type: 'success', // 'success' or 'error'
})

export function useToast() {
  const showToast = (message, type = 'success', duration = 3000) => {
    toast.value = { show: true, message, type }
    setTimeout(() => {
      toast.value.show = false
    }, duration)
  }

  // Expose the shared state and the method to update it
  return {
    toast,
    showToast,
  }
}
